module.exports = __webpack_public_path__ + "img/logo-xd.46bbd281.svg";